import actions from "./actions";

const initState = {
  schools: [],
  roles: [],
  grades: [],
  subjects: [],
  users: [],
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_CONFIG_SUCCESS:
      return {
        ...state,
        schools: action.payload.schools,
        roles: action.payload.roles,
        grades: action.payload.grades,
        subjects: action.payload.subjects,
      };
    case actions.FETCH_USER_LIST_ZOOM_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };
    default:
      return state;
  }
}
